<template>
  <div class="wrapper">
    <div class="topMenu">
      <router-link to="/about">About</router-link>
    </div>
    <HeaderComponent
      title="Center of the universe"
      subtext="Begin your amazing journey through our galaxy, and space. Gather some
        exciting informations about the universe around us."
    />
    <div class="menu">
      <router-link to="/image-library">
        <div class="option" id="first-option">
          <p>
            Explore the universe and browse tons of interesting photos from
            space!
          </p>
        </div>
      </router-link>
      <hr />
      <router-link to="/rovers">
        <div class="option">
          <p>Choose one of the Mars rovers, and see what it captured!</p>
        </div>
      </router-link>
      <hr />
      <router-link to="/mars-weather">
        <div class="option">
          <p>Check the current weather conditions on Mars!</p>
        </div>
      </router-link>
      <hr />
      <router-link to="/asteroid-monitor">
        <div class="option" id="last-option">
          <p>See if any asteroids are approaching Earth!</p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent.vue";

export default {
  name: "HomeView",
  components: {
    HeaderComponent,
  },
};
</script>

<style lang="scss">
body {
  background-image: url("@/assets/earth-bg.webp");

  @media (min-height: 1090px) {
    background-color: black;
    background-clip: black;
    background-repeat: no-repeat;
    background-position-y: 290px;
  }
}

.menu {
  margin: auto;
  margin-top: 3%;
  width: 50%;

  @media (max-width: 425px) {
    width: 100%;
  }

  @media (max-width: 768px) {
    width: 90%;
  }

  @media (max-width: 1024px) {
    width: 100%;
  }
}

.menu > hr {
  width: 40%;

  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.75),
    rgba(255, 255, 255, 0)
  );

  border: 0;
  height: 1px;

  margin-top: 0px;
  margin-bottom: 0px;

  @media (max-width: 425px) {
    width: 65%;
  }

  @media (max-width: 768px) {
    width: 70%;
  }

  @media (max-width: 1024px) {
    width: 60%;
  }
}

.option {
  width: 65%;
  display: inline-block;

  padding-bottom: 5px;
  padding-top: 5px;

  margin-left: auto;
  margin-right: auto;

  text-align: center;

  @media (max-width: 425px) {
    width: 80%;
  }

  @media (max-width: 768px) {
    width: 65%;
  }
}

a:hover {
  text-shadow: 0 0 20px white, 0 0 20px white;
}

.topMenu {
  top: 20px;
  position: absolute;
  right: 30px;
}

.topMenu,
.topMenu > a,
.topMenu > a:hover {
  color: white;
}
</style>
